import { useContext } from 'react';
import { AppStateContext } from './app_state_context';

export function useAppState() {
  const context = useContext(AppStateContext);

  if (context === null) {
    throw new Error('AppState must be used within a AppStateContextProvider');
  }

  return context;
}
